/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import { useId } from 'react-aria';

import styles from '../FormBuilder.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import messages from '../l10n/formBuilderL10n';
import { getFieldTitle } from 'src/shared/app/base/component/data-entry/form-builder/utils/FormBuilderUtils';

import FormBuilderField from '../FormBuilderField';

import type { Field } from 'src/shared/app/base/component/data-entry/form-builder/type/formBuilderTypes';

const useStyles = createUseThemeStyles(styles);

const FormBuilderCheckboxList = ({ field, name }: Field): React.Node => {
  const classes = useStyles();
  const intl = useIntl();
  const labelId = useId();
  return (
    <>
      <label id={labelId}>
        {getFieldTitle(field, intl)}
        <br />
        <span className={classes.labelSubtitle}>
          {intl.formatMessage(messages.checklistChoose)}
        </span>
      </label>
      <div className={classes.checkboxList}>
        {field.choices?.map((choice) => (
          <FormBuilderField
            key={choice.key}
            field={choice}
            type="checkbox"
            name={`${name}.${choice.key}`}
            parentName={name}
            aria-describedby={labelId}
          />
        ))}
      </div>
    </>
  );
};

export default React.memo<Field>(FormBuilderCheckboxList);
